// extracted by css-extract-rspack-plugin
export default {"mpiFrame":"Pmw5LuD6","redirectFrame":"fYigvY8K","collectFrame":"BvI_3o5E","frame":"UHtb7mwu"};